<template>
    <vue-drag-resize class="point" 
                    :isActive="true" 
                    :isDraggable="true" 
                    :isResizable="isResizable" 
                    :w="w"
                    @resizestop="resizeStop"
                    :h="h" 
                    :x="x" 
                    :y="y" 
                    :minw="1" 
                    :minh="1" 
                    v-on:resizing="resize" 
                    v-on:dragging="resize"
                    @clicked="myClick"
    >
        <canvas v-if="drawData !=null" :id="'pc'+id" :width="w" :height="h"></canvas>
    </vue-drag-resize>

</template>

<script>
import {mapState, mapMutations, mapGetters} from 'vuex';
import VueDragResize from 'vue-drag-resize';
import * as mUtils from '@/utils/mUtils'

export default {
    name: 'point',
    computed: {
        ...mapState({
            userInfo: state => state.user.userInfo,
        }),
    },
    data() {
        return {
            selectElement: '', myStyle: null, squareStyle: {width: '15px', height: '15px', border: '1px solid red'},
            theDialogVisible: true,
            pw: 0, ph: 0, px: 0, py: 0,
        }
    },
    components: {
        VueDragResize
    },
    props: {
        id: String,
        h: {
            type: Number,
            default: 15,
        },
        w: {
            type: Number,
            default: 15,
        },
        x: Number,
        y: Number,
        drawData: {
            type: Object, require: false
        },
        isResizable: Boolean,
    },
    mounted: function () {

    },
    watch: {
        drawData: {
            deep: true, immediate: true,
            handler(n, o) {
                if (n) {
                    // 组件传入的位置元素（红框的长宽）
                    let that = this;
                    this.pw = this.w; 
                    this.ph = this.h; 
                    this.myData = n;
                    this.$nextTick(()=>{
                        // 显示答题卡答案框定的绿框
                        that.drawTheData();
                    });

                }
            }
        },
    },
    methods: {
        myClick(e) {
            // console.log('point click', e)
            this.$emit('select', this.id);
        },
        resizeStop(newRect) {
            console.log("resizestop", newRect)
            this.drawTheData();
        },
        drawTheData() {
            console.log('===============n-2=================')
            console.log(this.myData);

            if(!this.myData || this.myData == null) return;
            // 组件传入红框的ID，获取到对应的位置信息
            var canvas = document.getElementById("pc"+this.id);
            console.log('===============getElementById-pc=================')
            console.log(canvas);

            if (canvas.getContext) {
                // canvas内置方法，用作于建立一个可以绘制2D图像的画布
                let ctx = canvas.getContext('2d');
                // 画布样式配置
                ctx.width = this.pw; 
                ctx.height = this.ph;
                ctx.font = 'normal 10px Arial,sans-serif '; 
                ctx.strokeStyle = 'lightgreen';

                console.log('=======mydate =====');
                console.log(this.myData);
                let myType = this.myData.type
                let myList = this.myData.list
                let myPos = this.myData.position

                console.log("drawTheData", myType, this.myData, myList);

                let pw = this.pw
                let ph = this.ph;
                //  学号类型的定位
                if(myType == "regNo"){
                    let noCount = this.myData.count;
                    console.log("regNo", noCount);

                    // 学号长度可变，由传入的count值平均分
                    let w_g = pw / noCount;
                    // 学号选择范围默认0~9 ，高度默认平均十份
                    let h_g = ph / 10;
                    // 将每个平均分的小矩形再四等分
                    let g4 = w_g / 4;
                    let h4 = h_g / 4;
                    
                    for (let i = 0; i < noCount; i++) {
                        for (let j=0; j<10; j++){
                          // 根据不同行列数，计算出对应的x,y轴坐标
                          let ix = i * w_g
                          let iy = j * h_g
                          // canvas内置方法，清空子路径列表开始一个新路径的方法
                          ctx.beginPath();
                          // canvas内置方法，绘制矩形，传入x,y,width,heigh 信息
                          // 每个行列小矩形内再根据x轴的1/4,Y轴的1/8作为内矩形的起始点
                          ctx.rect(ix+g4, iy+h4/2, g4*2, h4*2);
                          // canvas内置方法，绘制当前或已经存在的路径的方法
                          ctx.stroke();
                        }
                    }
                }
                // 其余类型的定位
                if(myType == "Object"){
                    let b_x = 0
                    let b_y = 0;


                    // drawData内的list数据，可理解成红框内有几道题区（包含序号和选择项的范围 - 多个） - 红框分几个题区，题区内分几道题目
                    for (let i=0; i < myList.length; i++){

                        // 选择对应题区（红框内大绿框的部分-非选择项的绿框）
                        let branch = myList[i];
                        // 获得题区的位置信息(绿框-标准坐标) - height,left,top,width 
                        let pos = branch.position;
                        // ph,pw是所在红框的长宽（试卷红框-实际长宽），myPos答题卡答案的长宽（答题卡红框-标准长宽）
                        // 理想情况下，答题卡的长宽与扫描的长宽一致，定位点的X,Y轴就可以能直接定位。例（1,2)
                        // 但是实际情况试卷的长宽会改变，则定位点的x,y轴需要同框定的红框的长宽同步改变坐标，则如果红框等比例放大两倍则x,y应该变为(2,4)
                        // 计算方式: （ 标准坐标 / 标准长宽 = 标准坐标长宽比例 ） * 实际长宽 = 实际坐标   
                        let bchWidth = pw * pos.width / myPos.width;
                        let bchHeight = ph * pos.height / myPos.height;
                        let bchX = pw * pos.left / myPos.width;
                        let bchY = ph * pos.top / myPos.height;
                        // console.log("kuai", bchWidth, bchHeight, bchX, bchY);
                        ctx.beginPath();
                        ctx.rect(bchX, bchY, bchWidth, bchHeight);
                        ctx.stroke();

                        // ixList : 题区内的题目序号（行数）
                        let ixList = branch.ixList;
                        // 实际的X轴起始坐标（从绿框的0开始 ≈ x=0）
                        let ixX = bchX;
                        // 实际的Y轴起始坐标  + （2.5倍的）实际高度/标准高度 (绿框内上边距 约等于 y = 0 + 上边框)
                        let ixY = bchY + bchHeight * 2.5 / pos.height;
                        // （5倍的）实际高度/标准高度
                        let tiH = bchHeight * 5 / pos.height;

                        // ctx.strokeStyle = 'purple';
                        // ctx.beginPath();
                        // ctx.rect(ixX, ixY, 100, 0);
                        // ctx.stroke();

                        // 是否为判断题
                        let perPre = (branch.subAreaTopicType=="Judge")?"PD":"P";
                        // 根据选项数找到对应的缩放数组

                        // 获取比例 （比例换算版本 或 等分距离版本）
                        let percent_ = mUtils.getPercent(this.percentType)
                        // 根据选项数找到对应的缩放数组
                        let percent = percent_[perPre+branch.chooseCount];
                        // let percent = this.percent[perPre+branch.chooseCount];


                        // if(branch.chooseCount == 4)percent =this.percent["P12"]
                        
                        console.log('===========percent ==============');
                        console.log(percent);
                        console.log(perPre);
                        console.log(branch.chooseCount);
                        // 设定题区（小绿框）内每道题对应的行区（选择项的小绿框部分）
                        for (let j=0; j < ixList.length; j++){
                            // y轴坐标 + 行间距
                            let iY = ixY + j * tiH;
                            for (let k=0; k < percent.length; k++){
                                let tiX = bchX + bchWidth * percent[k][0];
                                let tiXEnd = bchX + bchWidth * percent[k][1];
                                let tiW = tiXEnd - tiX;
                                let tiGe = tiW / 4;
                                let tiHGe = tiH / 4;

                                // ctx.strokeStyle = 'blue';
                                
                                ctx.beginPath();
                                //  矩形的长宽不固定（目前看相差不大），会根据坐标进行改变
                                // ctx.rect(tiX+tiGe, iY, tiW - tiGe * 2, tiH - tiHGe);
                                ctx.rect(tiX+tiGe, iY, tiW *0.65, tiH - tiHGe);
                                ctx.stroke();

                                // console.log('Q============================================');
                                // console.log('tiX =' + tiX);
                                // console.log('tiX+tiGe =' + tiX+tiGe);
                                // console.log('iY =' + iY);
                                // console.log('tiW =' + tiW);
                                // console.log('tiGe =' + tiGe);
                                // console.log('tiHGe =' + tiHGe);
                                // let i = tiW - tiGe * 2
                                // console.log('tiW - tiGe * 2 =' + i);
                                // let w = tiH - tiHGe
                                // console.log('tiH - tiHGe =' + w);
                                // console.log('tiXEnd =' + tiXEnd);

                                // console.log("", j, k, tiX, tiGe, iY, tiH, tiW, tiW-tiGe, tiH-tiHGe )
                            }
                        }
                        ctx.strokeStyle = 'lightgreen';

                    }
                }

            }
        },
        resize(newRect) {
            // console.log("resize", newRect)
            this.pw = newRect.width;
            this.ph = newRect.height;
            this.py = newRect.top;
            this.px = newRect.left;
            this.$emit('repos', this.id, newRect);
        },
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

.point {
    border: solid 1px red;

}


</style>
